import { useIntl } from 'react-intl'

import { ButtonGroup, FormattedMessage } from '@subaio/components'
import { Form } from '@subaio/components/src/HookForm'

import type {
	Handlers,
	OpportunityCarInsuranceStep,
	OpportunityCarInsuranceStepType,
} from 'containers/OpportunityCarInsurance/handlers'

import { ButtonSolid, ButtonText } from 'components/Buttons'
import { Card } from 'components/Card'
import { Input } from 'components/FormFields'
import { Header } from 'components/Layout'

import { Title } from '../Title'

const dutchLicensePlateRegex =
	/(\w{2}-?\d{2}-?\d{2})|(\d{2}-?\d{2}-?\w{2})|(\d{2}-?\w{2}-?\d{2})|(\w{2}-?\d{2}-?\w{2})|(\w{2}-?\w{2}-?\d{2})|(\d{2}-?\w{2}-?\w{2})|(\d{2}-?\w{3}-?\d{1})|(\d{1}-?\w{3}-?\d{2})|(\w{2}-?\d{3}-?\w{1})|(\w{1}-?\d{3}-?\w{2})|(\w{3}-?\d{2}-?\w{1})|(\d{1}-?\w{2}-?\d{3})/

type Props = TaggedType<OpportunityCarInsuranceStep, OpportunityCarInsuranceStepType.LicensePlate> & {
	onShowDamageFreeYears: Handlers['onShowDamageFreeYears']
	onStepBack?: () => void
}

export const LicensePlate = ({ selectedInsurer, personalDetails, onShowDamageFreeYears, onStepBack }: Props) => {
	const { formatMessage } = useIntl()

	return (
		<Form
			validationMode='all'
			render={(_, { formState }) => (
				<Card>
					<Header>
						<Title>
							<FormattedMessage
								id='opportunityCarInsurance.licensePlate.title'
								defaultMessage='What is your license plate number?'
							/>
						</Title>
						<p>
							<FormattedMessage
								id='opportunityCarInsurance.personalForm.description'
								defaultMessage='Enter the license plate number of your car that you use for private purposes.'
							/>
						</p>
					</Header>
					<Input
						name='licensePlate'
						validate={(value) => {
							if (dutchLicensePlateRegex.test(value)) return true
							return formatMessage({
								id: 'opportunityCarInsurance.licensePlate.invalidLicensePlate',
								defaultMessage: 'Enter a valid license plate number',
							})
						}}
						label={
							<FormattedMessage
								id='opportunityCarInsurance.licensePlate.labelLicensePlate'
								defaultMessage='License plate'
							/>
						}
					/>
					<ButtonGroup center>
						{onStepBack && (
							<ButtonText
								label={<FormattedMessage id='opportunityCarInsurance.buttonBack' defaultMessage='Back' />}
								onClick={() => onStepBack()}
							/>
						)}
						<ButtonSolid
							label={<FormattedMessage id='opportunityCarInsurance.buttonContinue' defaultMessage='Continue' />}
							disabled={!formState.isValid}
							submit
						/>
					</ButtonGroup>
				</Card>
			)}
			onSubmit={({ licensePlate }) => onShowDamageFreeYears(selectedInsurer, personalDetails, licensePlate)}
		/>
	)
}
